import { Mail, Phone } from 'lucide-react';

// פרטי קשר - לעדכון בקלות
const CONTACT_EMAIL = 'Z6738802@gmail.com';
const CONTACT_PHONE = '0556738802';
const CONTACT_PHONE_DISPLAY = '055-673-8802';

export default function Footer() {
  return (
    <div className="mark-footer">
      <span className="mark-footer-brand">נבנה ע"י MARK Automations</span>
      <div className="mark-footer-contact">
        <a href={`mailto:${CONTACT_EMAIL}`}>
          <Mail size={13} /> {CONTACT_EMAIL}
        </a>
        <a href={`tel:${CONTACT_PHONE}`} dir="ltr">
          <Phone size={13} /> {CONTACT_PHONE_DISPLAY}
        </a>
      </div>
    </div>
  );
}
